import { render, staticRenderFns } from "./LinkCampaignModal.vue?vue&type=template&id=27c8334f"
import script from "./LinkCampaignModal.vue?vue&type=script&lang=js"
export * from "./LinkCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports